import '@/utils/log'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '@/style/index.styl'
import 'element-ui/lib/theme-chalk/index.css'

// 自定义工具
import version from '@/utils/version'
import locale from '@/utils/locale'
import '@/utils/flexible'
import '@/utils/screencheck'
// 版本检测
version.checkVersion()

// 自定义组件
import lPrompt from '@/components/l-prompt'
import lLoading from '@/components/l-loading'
import lToast from '@/components/l-toast'
import lReport from '@/components/l-report/index.js'

// 挂载自定义组件
Vue.use(lPrompt)
Vue.use(lLoading)
Vue.use(lToast)
Vue.use(lReport)

Vue.config.productionTip = false
// 中英对照
Vue.prototype.$locale = locale.en
window.$USERKEY = 'USER'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
